import { formatBookingCurrency } from '../../utils/bookingFormat';
import type { ServiceCostLine } from '../../hooks/usePublicBookingSelection';

interface BookingCostBreakdownProps {
	lines: ServiceCostLine[];
	total: number;
	totalLabel?: string;
}

/** Per-service prices at whatever size/length each service is priced by, plus the total. */
const BookingCostBreakdown = ({
	lines,
	total,
	totalLabel = 'Estimated Total',
}: BookingCostBreakdownProps) => (
	<div className="pb__cost">
		{lines.map(line => (
			<div key={line.id} className="pb__cost-row">
				<span className="pb__cost-name">{line.name}</span>
				<span className="pb__cost-price">{formatBookingCurrency(line.price)}</span>
			</div>
		))}
		<div className="pb__cost-total">
			<span className="pb__cost-total-label">{totalLabel}</span>
			<span className="pb__cost-total-amount">{formatBookingCurrency(total)}</span>
		</div>
	</div>
);

export default BookingCostBreakdown;
